import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";
import { InspectNodeScheduleResponse } from "../reducers/scheduleReducer";

export const fetchNodeSchedule = createAsyncThunk(
  "schedules/fetchNodeSchedule",
  async (targetsTestInfra: boolean = false) => {
    const response: InspectNodeScheduleResponse = await api(
      `schedules/inspect-node-schedule`,
      "POST",
      { targets_test_infra: targetsTestInfra },
      { usePixelsApi: true }
    );
    return response;
  }
);
